<ui-banner *ngIf="useBanner" variant="warning" class="margin-bottom-4">
    {{ 'payroll.run.otherRemittancesPay.humiDoesNotRemitProvincialHealthTaxesForAnyProvinceExceptForQueb' | translate }}
</ui-banner>

<p *ngIf="!useBanner" class="margin-bottom-4">
    {{ 'payroll.run.otherRemittancesPay.humiDoesNotRemitProvincialHealthTaxesForAnyProvinceExceptForQueb' | translate }}
</p>

<app-simple-table
    [columns]="columns"
    [rows]="rows"
    [showInlineButton]="true"
    [inlineButtonText]="'payroll.run.otherRemittancesPay.completePayment'"
    inlineButtonIcon="openInNew"
    inlineButtonSpan="columns-3"
    (inlineButtonClicked)="goToPay($event)"
/>
